const getters = {
  globalLoading: (state) => state.globalLoading,
  globalLoadingMessageArray: (state) => state.globalLoadingMessageArray,
  snackbar: (state) => state.snackbar,
  snackbarType: (state) => state.snackbarType,
  snackbarText: (state) => state.snackbarText,
  confirmationDialog: (state) => state.confirmationDialog,
  confirmationDialogConfig: (state) => state.confirmationDialogConfig,
  exibirMensagem: (state) => state.exibirMensagem,
  tituloMensagem: (state) => state.tituloMensagem,
  textoMensagem: (state) => state.textoMensagem
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/ui/getters.js